import { __rest, __awaiter } from '../../../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import 'react';
import '@dynamic-labs/utils';
import '@dynamic-labs/sdk-api';
import '../../../../config/ApiEndpoint.js';
import '../../../../shared/logger.js';
import '../../../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import 'ethers';
import '../../../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import { isMagicConnector } from '../../../../utils/functions/isMagicConnector/isMagicConnector.js';
import '@dynamic-labs/rpc-providers';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import '../../../../context/AccessDeniedContext/AccessDeniedContext.js';
import 'react-dom';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../components/IconButton/IconButton.js';
import '../../../../components/Alert/Alert.js';
import '@dynamic-labs/wallet-book';
import '../../../../components/Popper/Popper/Popper.js';
import '../../../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../../../components/MenuList/Dropdown/Dropdown.js';
import { TransactionConfirmationView } from '../../../TransactionConfirmationView/TransactionConfirmationView.js';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { useTransactionWithGasPrice } from '../../../../utils/hooks/useTransactionWithGasPrice/useTransactionWithGasPrice.js';

const TransactionStage = (_a) => {
    var { transaction, provider, walletConnector } = _a, rest = __rest(_a, ["transaction", "provider", "walletConnector"]);
    const { disableWalletConfirmationOnce } = useInternalDynamicContext();
    const transactionWithGasPrice = useTransactionWithGasPrice({
        enabled: isMagicConnector(walletConnector),
        increasePercentage: 5,
        provider,
        transaction,
    });
    return (jsx(TransactionConfirmationView, Object.assign({ provider: provider, transaction: transactionWithGasPrice, mutation: () => __awaiter(void 0, void 0, void 0, function* () {
            disableWalletConfirmationOnce();
            const signer = provider.getSigner();
            const sentTransaction = yield signer.sendTransaction(transactionWithGasPrice);
            return sentTransaction;
        }) }, rest)));
};

export { TransactionStage };
